<template>
  <div>
    <div
      v-if="isShow && params.title"
      id="topNotice"
      class="notice-top"
    >
      <div class="content">
        <el-tag
          type="danger"
          size="mini"
          effect="dark"
          class="notice-tag"
        >
          {{ params.tag_title }}
        </el-tag>
        <span>{{ params.title }}</span>
        <el-button
          type="text"
          class="detail-btn"
          @click="handleJump(params.url)"
        >
          查看详情
        </el-button>
        <i
          class="el-icon-circle-close notice-close"
          @click="handleClose"
        />
      </div>
    </div>

    <el-row
      v-if="isShow && params.title"
      class="fix"
    />
  </div>
</template>

<script>
export default {
  name: 'SpNotice',
  data () {
    return {
      isShow: true,
      lastisShow: undefined,
      params: {
        title: '',
        tag_title: '',
        url: ''
      }
    }
  },
  watch: {
    $route (to, from) {
      if (to.path === '/salescenter') {
        this.lastisShow = this.isShow
        this.isShow = false
        localStorage.setItem('isShowTopNotice', false)
        localStorage.setItem('lastisShow', this.lastisShow)
        this.$emit('closeBlank', false)
      }
      if (from.path === '/salescenter') {
        this.isShow = localStorage.getItem('lastisShow') === 'true'
        localStorage.setItem('isShowTopNotice', this.isShow)
        if (this.isShow === true) {
          this.$emit('closeBlank', true)
        }
      }
    }
  },
  created () {
    this.getAdminList()
    this.isShow =
      localStorage.getItem('isShowTopNotice') === 'true' ||
      localStorage.getItem('isShowTopNotice') == null
  },
  methods: {
    handleClose () {
      this.isShow = false
      localStorage.setItem('isShowTopNotice', false)
      this.$emit('closeBlank', false)
    },
    handleJump (value) {
      window.open(value, '_blank')
    },
    async getAdminList () {
      const data = await this.$api.setting.getAdminList({
        page: 1,
        page_size: 6
      })
      if (data) {
        this.params = data.notice || {
          title: '',
          tag_title: '',
          url: ''
        }
      } else {
        this.isShow = false
        this.$emit('closeBlank', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-top {
  width: 100%;
  height: 50px;
  padding-right: 20%;
  // margin-bottom: 50px;
  background-color: #fffdef;
  position: fixed;
  top: 50px;
  right: 0px;
  left: 264px;
  z-index: 9;
  .content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .notice-tag {
      margin-right: 10px;
    }
    .detail-btn {
      margin: 0 10px;
    }
    .notice-close {
      color: #ff0000;
      font-size: 14px;
      cursor: pointer;
    }
  }
  margin-bottom: 5px;
}
.isFixed {
  position: fixed;
  background-color: #fff;
  top: 0;
  z-index: 999;
}
.bg-purple-dark {
  background: #000;
  min-height: 36px;
}
.fix {
  height: 50px;
}
</style>
